import React, { useEffect, useState } from 'react';
import { Table, Button, Spinner, Alert, Modal, Form } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import axiosInstance from "../../../api/api";

const initialForm = {
  id: null,
  nombre: '',
  estrategia: '',
  tiempo: '',
  nivelRecordacion: '',
  tipo: '',
  porcentajeParticipacion: '',
  competitorId: null
};

const DetailCompetitor = ({ competitorId, refrescar }) => {
  const [details, setDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState(initialForm);
  const [isEdit, setIsEdit] = useState(false);
  const [tableHeaders, setTableHeaders] = useState([]);
  const [infoModal, setInfoModal] = useState({ show: false, content: '' });

  // Cargar datos al iniciar
  useEffect(() => {
    if (competitorId) {
      fetchDetails();
    }
  }, [competitorId]);

  const fetchDetails = async () => {
    setLoading(true);
    setError(null);
    try {
      //titulos y campos mercado Objetivo
      await axiosInstance.get('/detailoption/option/value/competitorTable').then((response) => {
        setTableHeaders(response.data.data);
        console.log("tabla competitor" + tableHeaders)
      }).catch((e) => {
        alert("Error consultando la tabla " + e)
      });
    } catch (error) {
      setError('Error al cargar los detalles');
      console.error(error);
    } finally {
      setLoading(false);
    }

    if (competitorId.id) {
      await axiosInstance.get('demanda/detailCompetitor/' + competitorId.id).then((response) => {
        if (response) {
          setDetails(response.data.data || []);
        }
        console.log(setDetails)
      }).catch((e) => {
        alert("Error consultando la tabla ")
      });
    }

  };

  const handleShowModal = (detail = null) => {
    if (detail) {
      setForm(detail);
      setIsEdit(true);
    } else {
      setForm({ ...initialForm, competitorId });
      setIsEdit(false);
    }
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setForm(initialForm);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const handleSubmit = async () => {
    try {
      //calcular valores
      console.log("Guardando y calculando valores")
      console.log(form)
      //await axios.put(`/api/detailcompetitors/${form.id}`, form);
      await axiosInstance.post('demanda/detailCompetitor/' + competitorId.ciemId, form).then((response) => {
        if (response) {
          setDetails(response.data.data || []);
        }
        console.log("informacion consultada" + setDetails)
      }).catch((e) => {
        alert("Error consultando la tabla " + e.message)
      });
      handleCloseModal();
      await fetchDetails();
      refrescar();
    } catch (err) {
      alert('Error al guardar');
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar este registro?')) {
      try {
        await axiosInstance.delete(`demanda/detailCompetitor/${id}`);
        fetchDetails();
        refrescar();
      } catch (err) {
        alert('Error al eliminar');
      }
    }
  };

  return (

    <div>
      <div className="mb-3 text-end">
        <Button onClick={() => handleShowModal()} variant="primary">
          Nuevo Competidor
        </Button>
      </div>
      {loading && <Spinner animation="border" />}
      {error && <Alert variant="danger">{error}</Alert>}


      <div style={{ overflowX: "auto" }}>
        <Table striped bordered hover>
          <thead>
            <tr>
              {tableHeaders.map((titulo) => (
                <th key={titulo.id}>
                  <span className="d-flex align-items-center gap-1">
                    {titulo.description}
                    {titulo.tooltip && (
                      <Button
                        variant="link"
                        size="sm"
                        className="p-0 text-info"
                        onClick={() => setInfoModal({ show: true, content: titulo.tooltip })}
                        title="Ver información"
                      >
                        <FontAwesomeIcon icon={faInfoCircle} />
                      </Button>
                    )}
                  </span>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {(details || []).length > 0 ? (
              details.map((detail, index) => (
                <tr key={index}>
                  {tableHeaders.map((header, idx) => (
                    <td key={idx}>
                      {detail[header.value] || ""}
                    </td>
                  ))}
                  <td>
                    <Button size="sm" onClick={() => handleShowModal(detail)} className="me-2">
                      Editar
                    </Button>
                    <Button size="sm" variant="danger" onClick={() => handleDelete(detail.id)}>
                      Eliminar
                    </Button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center">
                  No hay registros disponibles.
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      {/* Modal para crear/editar */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{isEdit ? 'Editar Competidor' : 'Nuevo Competidor'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {['nombre', 'estrategia', 'tiempo', 'nivelRecordacion'].map((field) => (
              <Form.Group key={field} className="mb-2">
                <Form.Label>{field.charAt(0).toUpperCase() + field.slice(1)}</Form.Label>
                <Form.Control
                  name={field}
                  value={form[field] || ''}
                  onChange={handleChange}
                />
              </Form.Group>
            ))}
            <Form.Group className="mb-2">
              <Form.Label>Porcentaje Participación</Form.Label>
              <Form.Control
                type="number"
                step="0.01"
                name="porcentajeParticipacion"
                value={form.porcentajeParticipacion || ''}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Tipo Competidor</Form.Label>
              <Form.Control as="select" name="tipo" onChange={handleChange} value={form.tipo || ''}>
                <option>Directo</option>
                <option>Indirecto</option>
              </Form.Control>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal de información */}
      <Modal show={infoModal.show} onHide={() => setInfoModal({ show: false, content: '' })}>
        <Modal.Header closeButton>
          <Modal.Title>Información</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div dangerouslySetInnerHTML={{ __html: infoModal.content }} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setInfoModal({ show: false, content: '' })}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default DetailCompetitor;